module.exports = __webpack_public_path__ + "img/feature_dummy.e9106036.png";